import * as React from 'react';
import { TabPanel, Tabs } from 'react-tabs';

import { PageTitle } from '../pages/pageTitle';

import { EventsTableColumns } from './eventsTableQaQueue';
import { ActiveEventsTableQaContainer } from './eventsTableQaContainer';

const ActiveEventsTableColumns = [
  EventsTableColumns.ClientName,
  EventsTableColumns.EventName,
  EventsTableColumns.EventType,
  EventsTableColumns.EventStart,
  EventsTableColumns.EventReadyEstimate,
  EventsTableColumns.Assignee,
  EventsTableColumns.Status,
  EventsTableColumns.TotalParticipants,
  EventsTableColumns.ParticipantsWithClipsGenerated,
  EventsTableColumns.ClipGenerationErrors,
];

// eslint-disable-next-line react/prefer-stateless-function
export class EventsPageQaQueue extends React.Component {
  public render() {
    return (
      <>
        <PageTitle displayTitle="QA Queue" />
        <Tabs>
          <TabPanel>
            <ActiveEventsTableQaContainer columns={ActiveEventsTableColumns} />
          </TabPanel>
        </Tabs>
      </>
    );
  }
}
